import types from '../../constants';

export function selectUser(value) {
  return {
    type: types.EXERCISE_WAITING_SELECT,
    payload: value,
  };
}
